import React from "react";
import "style/Contact.scss";

import legacy from "config/i18n/legacy";
import ui from "config/i18n/ui";
import useLang from "hooks/useLang";
import usePageTitle from "hooks/usePageTitle";

import Reveal from "components/Reveal";

const Contact = () => {
  const lang = useLang();
  const language = legacy[lang];
  const c = ui[lang].contact;
  // label punctuation: French puts a no-break space before the colon,
  // Chinese and Japanese use the full-width colon
  const colon =
    lang === "fr" ? "\u00a0:" : lang === "zh" || lang === "ja" ? "：" : ":";
  usePageTitle(language.dropdown.contact);

  return (
    <div className="page">
      <header className="page__hero">
        <div className="shell">
          <h1>{language.contact.contactHeader}</h1>
        </div>
      </header>

      <main className="shell page__body">
        <Reveal className="page__card">
          <section className="contact-info">
            <div className="contact-info__row">
              <h2>
                {c.company}
                {colon}
              </h2>
              <p>MARKSIM SERVICES GMBH</p>
            </div>

            <div className="contact-info__row contact-info__addresses">
              <div>
                <p>
                  1220 VIENNA, AUSTRIA, EU
                  <br />
                  Oberdorfstrasse 9/1
                </p>
              </div>
              <span className="contact-info__and">{c.and}</span>
              <div>
                <p>
                  3701 GROSSWEIKERSDORF, AUSTRIA, EU
                  <br />
                  Kreuzbergstrasse 10
                </p>
              </div>
            </div>

            <div className="contact-info__row">
              <h2>
                {c.register}
                {colon}
              </h2>
              <p>FN461691h</p>
            </div>
            <div className="contact-info__row">
              <h2>
                {c.vat}
                {colon}
              </h2>
              <p>AT U71709001</p>
            </div>
            <div className="contact-info__row">
              <h2>
                {c.gln}
                {colon}
              </h2>
              <p>9110024112908</p>
            </div>
            <div className="contact-info__row">
              <h2>
                {c.phone}
                {colon}
              </h2>
              <p>
                <a href="tel:004312051085250">+43 1 205 108 525-0</a>
              </p>
            </div>
            <div className="contact-info__row">
              <h2>
                {c.email}
                {colon}
              </h2>
              <p>
                <a href="mailto:contact@marksim.org">contact@marksim.org</a>
              </p>
            </div>
            <div className="contact-info__row">
              <h2>
                {c.court}
                {colon}
              </h2>
              <p>{c.courtValue}</p>
            </div>

            <p className="contact-info__note">
              {c.details}{" "}
              <a
                href="https://firmen.wko.at/marksim-services-gmbh/wien/?firmaid=a8ed2291-a55d-4e6d-8c7b-ad83a4caea0f&suchbegriff=marksim"
                target="_blank"
                rel="noopener noreferrer"
              >
                {c.wko}
              </a>
            </p>
          </section>
        </Reveal>
      </main>
    </div>
  );
};

export default Contact;
